import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
            isFollowing: $options.isFollowing,
            onFollow: $options.onFollow,
            onUnfollow: $options.onUnfollow,
            canFollow: $options.canFollow,
            followRestrictionReason: $options.followRestrictionReason
        })))
  ]))
}